import { Component } from '@angular/core';
import { NavigatorService } from 'src/app/services/navigator.service';
import { UserDataService } from 'src/app/services/user-data.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MongoService } from 'src/app/services/mongo.service';

@Component({
  selector: 'statute-accept-dialog',
  templateUrl: './statute-accept-dialog.component.html',
  styleUrl: './statute-accept-dialog.component.css'
})
export class StatuteAcceptDialogComponent {
  checkBox = false;
  // pumpCheckbox = false;

  public get StatutesChecks() {
    return this.checkBox; //tu rozbudować po dodaniu kolejnych regulaminów za pomocą &&
  }

  constructor(
    private dialogReference: MatDialogRef<StatuteAcceptDialogComponent>,
    private navigator: NavigatorService,
    private userDataService: UserDataService,
  ){}

  downloadPdf(name:string){
    const pdfUrl = `assets/statutes/${name}.pdf`; // Ścieżka do pliku PDF w katalogu assets
    const a = document.createElement('a');
    a.href = pdfUrl;
    a.download = `${name}.pdf`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  toggleAirconditionCheckBox(event: Event){
    const checked = (event.target as HTMLInputElement).checked;
    this.checkBox = checked;
  }

  confirm(){
    // this.navigator.redirectToLandingPage();
    this.userDataService.updateUserStatutesState(true, true);
    this.dialogReference.close();
  }

  async cancel(){
    await this.userDataService.signOut(true);
    this.dialogReference.close();
  }
}
